import { render, staticRenderFns } from "./MarketFilter.vue?vue&type=template&id=55b29d78&"
import script from "./MarketFilter.vue?vue&type=script&lang=js&"
export * from "./MarketFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports